import React from 'react';

export const SampleBadgePicked = () => {
    return (
        <span className="badge li-bg-picked ml-2 li-fg-white">PICKED</span>
    );
};